export default "/imgs/tag/violations.svg"